import Renderer from './renderers/renderer';
import Mutator from './renderers/mutator';
import * as Actions from './actions/actions';
import reducer from './reducers/index';
import {waitForIvaFunction} from '../lib-alight-library/lib-alight-library';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { Store } from 'redux';
import { AlightStateType } from '../../types/alight-state';

const reduceReducers = (reducers: any[]) => {
    return (previous: any, current: any) =>
        reducers.reduce(
            (p,r) => r(p, current), previous
        );
};

export default class LaunchWindow {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;
    _renderer: Renderer;
    _mutator: Mutator;
    _mutatorModules: any;
    _childComponents: any;
    _mutators: any;
    _childRenderers: any;

    constructor(settings: AlightCustomSettingsType, mutatorModules = [], childComponents = []) {
        this._settings = settings;
        this._renderer = new Renderer(settings);
        this._mutator = new Mutator(settings);
        this._mutatorModules = mutatorModules;
        this._childComponents = childComponents;
    }

    getReducer() {
        const reducers = [];

        reducers.push(reducer);

        this._childComponents.forEach((item: any) => {
            reducers.push(item.getReducer());
        });

        return reduceReducers(reducers);
    }

    getRenderer() {
        return this._renderer.getRender();
    }

    getMutator() {
        return this._mutator.getMutate();
    }

    initialize(store: Store<AlightStateType>, initializationPromises: any) {
        this._store = store;
        this.setupGlobal();
        this.setupUserLoggedIn();
        this._mutators = [];
        this._childRenderers = [];

        this._mutatorModules.forEach((item: any) => {
            this._mutators.push(item.getMutator());
        });

        this._childComponents.forEach((item: any) => {
            this._childRenderers.push(item.getRenderer());
        });

        this._renderer.initialize(store, initializationPromises, this._mutators, this._childRenderers);
        this._mutator.initialize(store);
    }   //  end function initialize


    setupGlobal() {
        const setupGlobal = this._settings.launchPoint.setupGlobal;
        if(!setupGlobal) return;

        const globalName = this._settings.launchPoint.globalFunctionName;
        if(!globalName) return;

        const stateMinimizeLocation = this._settings.stateLocations.Window.IsMinimized;

        window.NITLaunchAgent = (channel? : string, pointOfNeed? : string): void => {
            waitForIvaFunction().then((result) =>{
                if(result !== true){
                    console.error("Timeout Waiting IVA Type Functions");
                    return false;
                }
                else{
                    if(pointOfNeed !== undefined){
                        this._store?.dispatch(Actions.setLaunchPointName(pointOfNeed));
                    }
                    
                    channel = channel?.toLowerCase();

                    for (const allowedChannels of Object.keys(this._settings.channelConstants.channels)) {
                        if(channel === allowedChannels.toLowerCase()){
                            this._store?.dispatch(Actions.setChannel(allowedChannels));
                        }
                    }

                    if(channel === "mobile")
                    {
                        this._store?.dispatch(Actions.setChannel(this._settings.channelConstants.channels.MobileApp));
                    }

                    const ivaEmbed = document.getElementById(this._settings.Window.embeddedRootId);
                    if(ivaEmbed){
                        console.log('found iva embed div updating restoring window with minimized=false');
                        this._store?.dispatch(Actions.restoreAlmeWindow('false'));
                    }else{
                        this._store?.dispatch(Actions.restoreAlmeWindow(stateMinimizeLocation));
                    }

                    // const offersAvailable = this._store?.getState().Offers?.OffersAvailable ?? [];

                    // offersAvailable.forEach((offer)=>{
                    //     this._store?.dispatch(Actions.markOfferProvided(offer));
                    // });


                    return true;
                } 
            });
        };
    }   //  end function setupGlobal

    setupUserLoggedIn(){
        const userloggedIn = this._settings.userLoggedIn.loggedInFunctionName;

        if (!userloggedIn) return;

        const resetStateLocation = `${this._settings.stateLocations.GenerateNewSession.Base}.${this._settings.stateLocations.GenerateNewSession.resetEnabled}`;
        window.userLoggedIn = () => {
            // set the userAuthenticated flag to true since this function is only called when we need to do that
            const userAuthenticated = true;
            this._store?.dispatch(Actions.setResetFunctionFlag(resetStateLocation, userAuthenticated));
        };
    }

}   //  end class LaunchWindow



// WEBPACK FOOTER //
// ./modules/window-launch/window-launch.ts